import type { ComponentProps } from "react";

import {
  SettingController as SettingControllerUI,
  useTargetTemperatureEditor,
} from "@utilifeed/components/propai";
import { useOrganization } from "@core/apis/PropAI";

type PropAISettingControllerProps = Readonly<{
  substationId: string;
  flexStationUid?: string;
  routeContextAddress?: string;
}>;

export function SettingController({
  substationId,
  flexStationUid,
  routeContextAddress,
}: PropAISettingControllerProps) {
  const { data: organization } = useOrganization();
  const editorProps = useTargetTemperatureEditor(substationId, {
    flexStationUid,
    address: routeContextAddress,
    isAdmin: organization?.is_admin ?? false,
  });
  return <SettingControllerUI {...(editorProps as ComponentProps<typeof SettingControllerUI>)} />;
}
